import React from "react";

const GetAppHome = () => {
  return (
    <div>
      <div
        className="container-fluid"
        style={{ backgroundColor: "rgb(255, 251, 247)" }}
      >
        <div className="container row py-4 m-auto">
          <div className="col-md-2"></div>
          <div className="col-md-4">
            <img
              src="https://b.zmtcdn.com/data/o2_assets/a500ffc2ab483bc6a550aa635f4e55531648107832.png"
              className="img-fluid"
              alt=""
            />
          </div>

          <div className="col-md-4">
            <h1 className="mb-4">Get The Zomato App</h1>
            <p className="mb-4">
              We will send you a link, open it on your phone to download the app
            </p>

            <input type="radio" name="Email" placeholder="Email" />
            <label className="ms-2">Email</label>
            <input
              className="ms-4"
              type="radio"
              name="Phone"
              placeholder="Phone"
            />
            <label className="ms-2">Phone</label>

            <div className="mt-4">
              <form class="d-flex" role="search">
                <input
                  class="form-control me-2"
                  type="search"
                  placeholder="Search"
                  aria-label="Search"
                  style={{ width: "60%" }}
                />
                <button class="btn btn-danger sbtnMobile" type="submit">
                  Share App Link
                </button>
              </form>
            </div>

            <div className="mt-4 row">
              <p className="text-secondary">Download App From</p>
              <div className="col-md-6 imgColAppMobile">
                <img
                  src="https://b.zmtcdn.com/data/webuikit/23e930757c3df49840c482a8638bf5c31556001144.png"
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="col-md-6 imgColAppMobile">
                <img
                  src="https://b.zmtcdn.com/data/webuikit/9f0c85a5e33adb783fa0aef667075f9e1556003622.png"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="col-md-2"></div>
        </div>
      </div>
    </div>
  );
};

export default GetAppHome;
